import { BREAKPOINTS } from "@styles/breakpoints";
export var generateColumns = function (columnSizes) {
    if (!columnSizes)
        return null;
    var brekpoints = Object.keys(BREAKPOINTS);
    return columnSizes.reduce(function (columns, size, index) {
        if (index === 0)
            return "col-" + (size !== null && size !== void 0 ? size : 12);
        if (!size)
            return columns;
        return columns + " col-" + brekpoints[index] + "-" + size;
    }, "");
};
